export const HOUSEHOLD_RESILIENCE_CREATE_FAIL = 'HOUSEHOLD_RESILIENCE_CREATE_FAIL'
export const HOUSEHOLD_RESILIENCE_CREATE_REQUEST = 'HOUSEHOLD_RESILIENCE_CREATE_REQUEST'
export const HOUSEHOLD_RESILIENCE_CREATE_SUCCESS = 'HOUSEHOLD_RESILIENCE_CREATE_SUCCESS'

export const HOUSEHOLD_RESILIENCE_LIST_FAIL = 'HOUSEHOLD_RESILIENCE_LIST_FAIL'
export const HOUSEHOLD_RESILIENCE_LIST_REQUEST = 'HOUSEHOLD_RESILIENCE_LIST_REQUEST'
export const HOUSEHOLD_RESILIENCE_LIST_SUCCESS = 'HOUSEHOLD_RESILIENCE_LIST_SUCCESS'

export const HOUSEHOLD_RESILIENCE_UPDATE_FAIL = 'HOUSEHOLD_RESILIENCE_UPDATE_FAIL'
export const HOUSEHOLD_RESILIENCE_UPDATE_REQUEST = 'HOUSEHOLD_RESILIENCE_UPDATE_REQUEST'
export const HOUSEHOLD_RESILIENCE_UPDATE_SUCCESS = 'HOUSEHOLD_RESILIENCE_UPDATE_SUCCESS'

export const HOUSEHOLD_RESILIENCE_DELETE_FAIL = 'HOUSEHOLD_RESILIENCE_DELETE_FAIL'
export const HOUSEHOLD_RESILIENCE_DELETE_REQUEST = 'HOUSEHOLD_RESILIENCE_DELETE_REQUEST'
export const HOUSEHOLD_RESILIENCE_DELETE_SUCCESS = 'HOUSEHOLD_RESILIENCE_DELETE_SUCCESS' 